/** Dashboard lug'ati (en): to'rt rol ko'rinishi va umumiy bloklar */
export default {
  loadError: "Could not load the dashboard.",
  greeting: { morning: "Good morning, {{name}}", afternoon: "Good afternoon, {{name}}", evening: "Good evening, {{name}}" },
  dateLine: "{{date}} · Dallas {{dallas}} {{abbr}} · Tashkent {{tashkent}}",
  period: "Period",
  daysValue_one: "{{count}} day",
  daysValue_other: "{{count}} days",
  delta: { same: "same as {{month}}", vs: "{{arrow}} {{count}} vs {{month}}" },
  kpi: {
    newDrivers: "New drivers",
    submitted: "Submitted to carriers",
    waitingReply: "{{count}} waiting for reply",
    hired: "Hired",
    pendingApproval: "+{{count}} pending approval",
    approvedByManager: "approved by manager",
    myBonus: "My bonus · {{month}}",
    bonusEstimated: "estimated, final after approval",
    hires: "Hires",
    hiresPrevIn: "{{count}} in {{month}}",
    pctVsPrev: "{{arrow}} {{pct}}% vs {{month}}",
    pendingShort: " · {{count}} pending",
    inPipeline: "In pipeline",
    activeDrivers: "active drivers",
    avgTimeToHire: "Avg time to hire",
    vsPrevNone: "vs {{month}}: —",
    daysVsPrev: "{{arrow}} {{count}} days vs {{month}}",
    daysIn: "{{days}} in {{month}}",
    noHiresYet: "no hires yet",
    retention30: "30-day retention",
    retention30Sub: "hires that passed 30 days",
    costPerHire: "Cost per hire",
    costPerHireSub: "expenses + salaries + bonuses",
  },
  myFunnel: "My funnel · {{month}}",
  funnelHint: "% = conversion from the previous step",
  funnel: "Funnel · {{month}}",
  leaderboard: {
    title: "{{scope}} leaderboard · {{month}}",
    team: "Team",
    top: "Top recruiters · {{month}}",
    full: "Full leaderboard →",
    empty: "No approved hires yet this month.",
    you: " (you)",
    hires_one: "{{count}} hire",
    hires_other: "{{count}} hires",
  },
  lead: { title: "Team overview", team: "Team", recruiters: "Recruiters · {{month}}", rowHint: "Row click → recruiter report", empty: "No recruiters in your team yet." },
  manager: { title: "Branch overview", branch: "Branch", myBranches: "all my branches", teams: "Teams · {{month}}" },
  owner: { title: "Company overview", allBranches: "all branches", back: "Back to all branches", vs: "vs {{month}}", branches: "Branches · {{month}}", rowHint: "Row click → that branch's dashboard", branchesEmpty: "No branches yet." },
  cols: {
    recruiter: "Recruiter", team: "Team", lead: "Lead", recruiters: "Recruiters", new: "New", submitted: "Submitted", hired: "Hired",
    retention30: "Retention 30d", avgTime: "Avg time", branch: "Branch", budgetUsed: "Budget used", costPerHire: "Cost / hire", total: "Total",
  },
  hiresPerWeek: "Hires per week",
  hiresPerWeekSub: "approved hires, last 8 weeks",
  hiresTip: "Hires",
  retention: { days: "{{count}} days", of: " · {{retained}} of {{eligible}}" },
  lossEmpty: "No lost drivers in this period.",
  approvals: {
    title: "Pending approvals", waiting: "{{count}} waiting for your decision",
    hires: "Hires", expenses: "Expenses", bonuses: "Bonuses", transfers: "Transfers", review: "Review →", open: "Open Approvals",
  },
  recent: { title: "Recently updated", empty: "No drivers yet. Add your first driver." },
  tasks: { title: "Today's tasks", all: "All tasks →", empty: "Nothing due today. Nice.", markDone: "Mark done", doneFailed: "Could not mark the task as done" },
};
